<template>
  <div>
    <nav class="topnav navbar navbar-expand shadow navbar-light  bg-white" id="sidenavAccordion">
        <a 
            v-on:click.prevent="Nada"
            class="navbar-brand text-innovation" 
            href="">
            <img src="/static/img/icono.png" alt="" class="img-fluid">
            PSICOFAST
        </a>
        <button class="btn  btn-icon btn-transparent-dark order-1 order-lg-0 mr-lg-2" id="sidebarToggle" href="#"><i data-feather="menu"></i></button>
        <form v-on:submit.prevent="Nada" class="form-inline mr-auto d-none d-md-block">
            <div class="input-group input-group-joined input-group-solid">
                <input class="form-control mr-sm-2" type="search" placeholder="Buscar" aria-label="Search" />
                <div class="input-group-append">
                    <div class="input-group-text"><i data-feather="search"></i></div>
                </div>
            </div>
        </form>
        <ul class="navbar-nav align-items-center ml-auto">
            <li class="nav-item dropdown no-caret mr-3 d-md-none">
                <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="searchDropdown" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i data-feather="search"></i></a>
                <!-- Dropdown - Search-->
                <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--fade-in-up" aria-labelledby="searchDropdown">
                    <form class="form-inline mr-auto w-100">
                        <div class="input-group input-group-joined input-group-solid">
                            <input class="form-control" type="text" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />
                            <div class="input-group-append">
                                <div class="input-group-text"><i data-feather="search"></i></div>
                            </div>
                        </div>
                    </form>
                </div>
            </li>
            <li class="nav-item  no-caret mr-3 d-none d-md-inline">
                    <a class="nav-link " id="navbarDropdownDocs" href="" v-on:click.prevent="Nada">
                        <div class="d-none d-md-inline font-weight-500">
                            {{perfil.nombre}}
                        </div>
                    </a>
                </li>
            <li class="nav-item dropdown no-caret mr-2 dropdown-user">
                <a 
                    class="btn btn-icon btn-transparent-dark dropdown-toggle" 
                    id="navbarDropdownUserImage" 
                    href="javascript:void(0);" 
                    role="button" 
                    data-toggle="dropdown" 
                    aria-haspopup="true" 
                    aria-expanded="false">
                    <img class="img-fluid" :src="usuario.foto" />
                </a>
                <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
                    <h6 class="dropdown-header d-flex align-items-center">
                        
                        <img 
                            class="dropdown-user-img" 
                            :src="usuario.foto" />
                        
                        <div class="dropdown-user-details">
                            <div class="dropdown-user-details-name">{{usuario.nombre}}</div>
                            <div class="dropdown-user-details-email">
                                {{usuario.email}}
                            </div>
                        </div>
                    </h6>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="" v-on:click.prevent="Salir">
                        <div class="dropdown-item-icon"><i data-feather="log-out"></i></div>
                        Salir
                    </a>
                </div>
            </li>
        </ul>
    </nav>
    <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
        <nav class="sidenav shadow-right sidenav-light">
            <div class="sidenav-menu ">
                <div class="nav accordion" id="accordionSidenav">
                    <div class="sidenav-menu-heading">Tablero</div>
                    <a 
                        v-on:click.prevent="EjecutarRuta('Dashboard')"
                        :class="{
                            'li_active':menu.opcion_activa=='Dashboard'
                        }"
                        class="nav-link " 
                        href="">
                        <div class="nav-link-icon">
                            <i data-feather="activity"></i>
                        </div>
                        Dashboard
                    </a>
                    <a 
                        v-on:click.prevent="EjecutarRuta('Mensajes')"
                        :class="{
                            'li_active':menu.opcion_activa=='Mensajes'
                        }"
                        class="nav-link " 
                        href="">
                        <div class="nav-link-icon">
                            <i class="fas fa-envelope"></i>
                        </div>
                        Mensajes
                        <span 
                            v-if="menu.mensajes_no_leidos>0"
                            class="ml-3 badge badge-danger">
                            {{menu.mensajes_no_leidos}}
                        </span>
                    </a>
                    <div 
                        v-if="perfil.permisos.tests.agregar || perfil.permisos.tests.consultar"
                        class="sidenav-menu-heading">Tests
                    </div>
                    <a 
                        v-if="perfil.permisos.tests.agregar"
                        class="nav-link " 
                        :class="{
                            'li_active':menu.opcion_activa=='Aplicar_Prueba'
                        }"
                        v-on:click.prevent="EjecutarRuta('Aplicar_Prueba')"
                        href="">
                        <div class="nav-link-icon">
                            <i class="far fa-file-alt"></i>
                        </div>
                        Aplicar Prueba
                    </a>
                    <a 
                        v-if="perfil.permisos.tests.consultar"
                        class="nav-link " 
                        :class="{
                            'li_active':menu.opcion_activa=='Tests'
                        }"
                        v-on:click.prevent="EjecutarRuta('Tests')"
                        href="">
                        <div class="nav-link-icon">
                            <i class="fas fa-chart-pie"></i>
                        </div>
                        Pruebas Aplicadas
                    </a>
                    <div 
                        v-if="perfil.permisos.clientes.consultar || perfil.permisos.pruebas.consultar"
                        class="sidenav-menu-heading">
                        Admin
                    </div>
                    <a 
                        v-if="perfil.permisos.pruebas.consultar"
                        class="nav-link " 
                        :class="{
                            'li_active':menu.opcion_activa=='Pruebas'
                        }"
                        v-on:click.prevent="EjecutarRuta('Pruebas')"
                        href="">
                        <div class="nav-link-icon">
                            <i class="fas fa-spell-check"></i>
                        </div>
                        Pruebas
                    </a>
                    <a 
                        v-if="perfil.permisos.clientes.consultar"
                        v-on:click.prevent="EjecutarRuta('Clientes')"
                        :class="{
                            'li_active':menu.opcion_activa=='Clientes'
                        }"
                        class="nav-link " 
                        href="">
                        <div class="nav-link-icon">
                            <i class="fas fa-user-friends"></i>
                        </div>
                        Clientes
                    </a>
                    <div
                        v-if="perfil.permisos.usuarios.consultar || perfil.permisos.perfiles.consultar" 
                        class="sidenav-menu-heading">Config</div>
                    <a 
                        v-if="perfil.permisos.usuarios.consultar"
                        v-on:click.prevent="EjecutarRuta('Usuarios')"
                        :class="{
                            'li_active':menu.opcion_activa=='Usuarios'
                        }"
                        class="nav-link " 
                        href="">
                        <div class="nav-link-icon">
                            <i class="fas fa-user-cog"></i>
                        </div>
                        Usuarios
                    </a>
                    <a 
                        v-if="perfil.permisos.perfiles.consultar"
                        v-on:click.prevent="EjecutarRuta('Perfiles')"
                        :class="{
                            'li_active':menu.opcion_activa=='Perfiles'
                        }"
                        class="nav-link " 
                        href="">
                        <div class="nav-link-icon">
                            <i class="fas fa-key"></i>
                        </div>
                        Perfiles
                    </a>
                </div>
            </div>
            <div class="sidenav-footer">
                <div class="sidenav-footer-content">
                    <div class="sidenav-footer-subtitle">Iniciado Sesión:</div>
                    <div class="sidenav-footer-title">{{usuario.nombre}}</div>
                </div>
            </div>
        </nav>
      </div>
      <div id="layoutSidenav_content">
        <main>
            <header class="page-header page-header-dark bg-innovation pb-10" v-if="!menu.cargando_pdf">
                <div class="container-fluid">
                    <div class="page-header-content pt-4">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto mt-4">
                                <h1 class="page-header-title">
                                    <div class="page-header-icon"><i data-feather="activity"></i></div>
                                    {{menu.opcion_activa}}
                                </h1>
                                <div class="page-header-subtitle">{{menu.opcion_activa_descripcion}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div
                v-if="menu.ready" 
                class="container-fluid mt-n10">
                <router-view/>
            </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions,mapState} from 'vuex';
import {auth} from '@/firebase.js';
export default {
  data () {
    return {
      
    }
  },
  methods:{
    Salir(){
        auth.signOut().catch(function(error) {
          swal('Problemas para cerrar sesión','Favor de Intentar mas tarde','error');
        });
    },
    EjecutarRuta(route_name){
        console.log(route_name);
      this.$router.push({name:route_name});
    },
    Nada(){},
    ...mapActions(['ConsultarMensajesNoLeidos'])
  },
  computed:{
    ...mapState(['menu','usuario','perfil'])
  },
  created(){
    var that = this;
  },
  mounted(){
    var that = this;
    //Configurar Admin
    $(document).ready(function(){
        $('body').removeClass('bg-innovation');
        $('[data-toggle="tooltip"]').tooltip();

        // Enable Bootstrap popovers via data-attributes globally
        $('[data-toggle="popover"]').popover();

        $(".popover-dismiss").popover({
        trigger: "focus"
        });

        // Add active state to sidbar nav links
        var path = window.location.href; 

        // Toggle the side navigation
        $("#sidebarToggle").on("click", function(e) {
        e.preventDefault();
        $("body").toggleClass("sidenav-toggled");
        });

        // Activate Feather icons
        feather.replace();

        // Activate Bootstrap scrollspy for the sticky nav component
        $("body").scrollspy({
        target: "#stickyNav",
        offset: 82
        });

        // Scrolls to an offset anchor when a sticky nav link is clicked
        $('.nav-sticky a.nav-link[href*="#"]:not([href="#"])').click(function() {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
          if (target.length) {
            $("html, body").animate(
              {
                scrollTop: target.offset().top - 81
              },
              200
            );
            return false;
          }
        }
        });

        // Click to collapse responsive sidebar
        $("#layoutSidenav_content").click(function() {
        const BOOTSTRAP_LG_WIDTH = 992;
        if (window.innerWidth >= 992) {
          return;
        }
        if ($("body").hasClass("sidenav-toggled")) {
            $("body").toggleClass("sidenav-toggled");
        }
        });

        // Init sidebar
        let activatedPath = window.location.pathname.match(/([\w-]+\.html)/, '$1');

        if (activatedPath) {
        activatedPath = activatedPath[0];
        }
        else {
        activatedPath = 'index.html';
        }

        let targetAnchor = $('[href="' + activatedPath + '"]');
        let collapseAncestors = targetAnchor.parents('.collapse');

        targetAnchor.addClass('active');

        collapseAncestors.each(function() {
        $(this).addClass('show');
        $('[data-target="#' + this.id +  '"]').removeClass('collapsed');
         
        });


        that.ConsultarMensajesNoLeidos();
    });
    /*
    const ruta = this.$route.name;
    if (ruta=='Menu') {
        this.$router.push({name:'Dashboard'});
    }else{
        setTimeout(function(){
            console.log(ruta);
            that.$router.push({name:ruta});
        },1000);
    }
    */
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppMenu/Menu/Menu.vue